import type {
  DecoratedFileCollection,
  FileCollectionPath,
} from '@witmetrics/utils';
import { isEmpty } from '@witmetrics/utils/misc';
import { sortAlphabeticalByName } from '@witmetrics/utils/arrays';
import FileCollectionCrumbs from '@/components/FileCollectionCrumbs';
import MoveButton from '@/dialogs/MoveContentDialog/MoveButton';
import IconButton from '@/components/IconButton';
import { CloseIcon } from '@/icons';
import List from '@/components/List';
import CollectionListItem from '../CollectionListItem';
import { classes } from '../utils';

export type ContentListProps = {
  isFetchingData?: boolean;
  isSaving?: boolean;
  disableMoveToCurrent?: boolean;
  crumbs: FileCollectionPath[];
  fileCollections: DecoratedFileCollection[];
  onSelect: (fileCollectionId?: number) => void;
  onSave: (fileCollectionId?: number) => Promise<void>;
  onClose: () => void;
};

export default function ContentList({
  isFetchingData,
  isSaving,
  disableMoveToCurrent,
  crumbs,
  fileCollections,
  onSelect,
  onSave,
  onClose,
}: ContentListProps) {
  return (
    <>
      <div className={classes.header}>
        <FileCollectionCrumbs
          showHome={false}
          className={classes.breadcrumbs}
          crumbs={crumbs}
          onSelect={onSelect}
        />
        <div className={classes.buttons}>
          {!disableMoveToCurrent && (
            <MoveButton
              disabled={isSaving}
              isSaving={isSaving}
              onMove={() => onSave()}
            />
          )}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      {isEmpty(fileCollections) ? (
        <div className={classes.empty}>No collections</div>
      ) : (
        <List>
          {sortAlphabeticalByName(fileCollections).map((fc) => (
            <CollectionListItem
              key={fc.id}
              disabled={isSaving || isFetchingData}
              fileCollection={fc}
              onOpen={() => onSelect(fc.id)}
              onSave={() => onSave(fc.id)}
            />
          ))}
        </List>
      )}
    </>
  );
}
